import priceTypes from "./priceTypes";
import priceUnits from "./priceUnits";

// Prefill new cloud agreements. Never charged on their own; see getCloudPrice.
const defaultCloudPrices = {
	[priceTypes.CLOUD_START_FEE_AUDIO]: {
		type: priceTypes.CLOUD_START_FEE_AUDIO,
		name: "Cloud start fee (audiobook or podcast)",
		currency: "SEK",
		price: 249,
		unit: priceUnits.FIXED,
		vat: 0,
	},
	[priceTypes.CLOUD_START_FEE_EBOOK]: {
		type: priceTypes.CLOUD_START_FEE_EBOOK,
		name: "Cloud start fee (ebook)",
		currency: "SEK",
		price: 49,
		unit: priceUnits.FIXED,
		vat: 0,
	},
	[priceTypes.CLOUD_REVENUE_LIVE]: {
		type: priceTypes.CLOUD_REVENUE_LIVE,
		name: "Cloud revenue (live)",
		currency: "SEK",
		price: 49,
		unit: priceUnits.YEAR,
		vat: 0,
	},
	[priceTypes.CLOUD_REVENUE_INACTIVE]: {
		type: priceTypes.CLOUD_REVENUE_INACTIVE,
		name: "Cloud revenue (inactive)",
		currency: "SEK",
		price: 19,
		unit: priceUnits.YEAR,
		vat: 0,
	},
};

export default defaultCloudPrices;
